<template>
  <div class="demo-view">
    <!-- Tutorial Mode -->
    <div v-if="showTutorial" class="min-h-screen bg-theme-surface-2 py-8">
      <div class="max-w-4xl mx-auto px-4">
        <TutorialWizard
          @close="closeTutorial"
          @start-demo="startDemoFromTutorial"
        />
      </div>
    </div>

    <!-- Regular Demo Mode -->
    <div v-else class="demo-view">
      <!-- The component renders its own title; this bar only offers the
           tutorial (the old gradient banner repeated the title). -->
      <div class="mx-auto flex max-w-7xl justify-end px-6 pt-6">
        <Button variant="outline" @click="startTutorial">
          Start tutorial
        </Button>
      </div>
      <WebRTCDemo :mode="demoMode" @connection-established="onConnectionEstablished" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import WebRTCDemo from '../components/WebRTCDemo.vue'
import TutorialWizard from '../components/TutorialWizard.vue'
import { Button } from '@elveris/ui/button'

// Props
const props = defineProps<{
  mode?: string
  tutorial?: boolean
}>()

// Reactive state
const demoMode = ref<'host' | 'client'>('host')
const showTutorial = ref(false)

// Methods
const onConnectionEstablished = (info: { role: 'host' | 'client', connectionId: string }) => {
  console.log('Connection established:', info)
}

const startTutorial = () => {
  showTutorial.value = true
}

const closeTutorial = () => {
  showTutorial.value = false
}

const startDemoFromTutorial = (mode: 'host' | 'client') => {
  demoMode.value = mode
  showTutorial.value = false
}

// Lifecycle
onMounted(() => {
  // Set demo mode from URL parameter
  if (props.mode && (props.mode === 'host' || props.mode === 'client')) {
    demoMode.value = props.mode
  }

  // Show tutorial if explicitly requested
  if (props.tutorial) {
    showTutorial.value = true
  }
})
</script>

<style scoped>
.demo-view {
  width: 100%;
  height: 100%;
}
</style>